import {Component} from '@angular/core';


@Component({
    selector: 'restore-password-dialog',
    templateUrl: 'restore-password-dialog.component.html',
})
export class RestorePasswordDialog {

}
